import { render, staticRenderFns } from "./MenuAtlas.vue?vue&type=template&id=67059351&"
import script from "./MenuAtlas.vue?vue&type=script&lang=js&"
export * from "./MenuAtlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports